import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TagModule } from '../../tag';
import { BodisplayModule, BoPropertyInlineModule, DynamictagsInlineModule, DynamicTagAddonModule } from '../../bodisplay';
import { CustomgridModule } from '../../customgrid';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { Route, RouterModule, } from '@angular/router';

import { StageModalComponent } from './stage-onglet/00.Modal/stage-modal.component';
import { ConventionComponent, CertificationComponent, DocumentComponent, EffectifComponent, ExtranetComponent, PlanningComponent, TacheComponent, TestComponent, Vue360Component, MailComponent, StageReportingComponent } from './stage-onglet';


import { PipeModule } from '../../pipes';
import { DateModule } from '../../date';
import { EffectifsModule } from '../../effectif';
import { AvatarSearchModule } from '../../avatar-search';
import { AvatarSearchValue, TacheTableauComponent } from './stage-onglet/09.Taches/Tableau/tacheTableau.component';
import { HistoryModule } from '../../history';
import { SendMailModule } from '../../mail';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { ListDocumentsComponent } from './stage-onglet/04.Documents/list-documents/list-documents.component';
import { GenerationDocumentsComponent } from './stage-onglet/04.Documents/generation-documents/generation-documents.component';
import { GenerationContratFormateurComponent } from './stage-onglet/04.Documents/generation-contrat-formateur/generation-contrat-formateur.component';
import { ListReservationComponent } from './stage-onglet/04.Documents/list-reservation/list-reservation.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AffectationComponent } from './stage-onglet/07.Extranet/Questionnaires/Affectation/affectation.component';
import { InsertDocInputModule, InsertDocModule } from '../../insertdoc';
import { UtilitiesDirectivesModule } from '../../utilities';

import { PortailExtranetComponent } from './stage-onglet/07.Extranet/Extranet/portail-extranet.component';
import { QuestionnairesExtranetComponent } from './stage-onglet/07.Extranet/Questionnaires/questionnaires-extranet.component';
import { DigitalLearningExtranetComponent } from './stage-onglet/07.Extranet/DigitalLearning/digital-learning-extranet.component';

import { RelatedDocumentModule } from '../../related-documents';
import { Documents360Component } from './stage-onglet/01.Vue360/Documents/documents360.component';
import { LieuComponent } from '../../lieu/lieu.component';

//import { EffectifsClientsSurStageModule } from '../../effectif/client-sur-stage';
import { FormateursIdPipe, NumberToFixedPipe } from './stage-onglet/03.Planning/planning.pipe';
import { CalendrierComponent } from './stage-onglet/03.Planning/calendrier/calendrier.component';
import { ListeReservationComponent } from './stage-onglet/03.Planning/liste-reservations/liste-reservations.component';
import { PlanningCreationComponent } from './stage-onglet/03.Planning/planning-creation/planning-creation.component';
import { QLeafMapModule } from '../../leaf-map';
//l'import de @fullcalendar/angular doit se trouver avant n'import que le plugin FullCalendar sinon une erreur de compilation surviendra.
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
//import listPlugin from '@fullcalendar/list';
//import timePlugin from '@fullcalendar/timegrid';
import { ReservationsBureauComponent } from './stage-onglet/03.Planning/reservations-bureau/reservations-bureau.component';
import { MailOneComponent } from './stage-onglet/10.Mail/mail-one/mail-one.component';
import { MailTwoComponent } from './stage-onglet/10.Mail/mail-two/mail-two.component';
import { MailThreeComponent } from './stage-onglet/10.Mail/mail-three/mail-three.component';
import { AutoSearchModule } from '../../autosearch';
import { StageDuplicationComponent } from './stage-onglet/00.Modal/Duplication/duplication.component';
import { QuestionnaireModule, ResultComponent } from '../../questionnaire';
import { ClientConventionComponent } from './stage-onglet/05.Convention/client-convention/client-convention.component';
import { CorpsConventionComponent } from './stage-onglet/05.Convention/client-convention/corps-convention/corps-convention.component';
import { SearchModule } from '../../search';

import { ESignatureModule } from '../../esignature/esignature.module';
import { ReportingModule } from '../../reporting';
import { BasicEchartModule } from '../../basic-echart/basic-echart.module';
import { ReservationModule } from '../../agenda';
import { DepensesComponent } from './stage-onglet/12.Depenses/depenses.component';
import { CreateObjectifComponent } from './stage-onglet/06.Certification/create-objectif/create-objectif.component';


//FullCalendarModule.registerPlugins([ // register FullCalendar plugins
//  dayGridPlugin,
//  interactionPlugin,
//  //listPlugin,
//  //timePlugin
//]);


export const StageRoutes: Route =
{
  path: 'stage-detail/:id', component: StageModalComponent, children: [
    { path: '', redirectTo: "vue360", pathMatch: "full" },
    { path: 'vue360', component: Vue360Component },
    { path: 'effectif', component: EffectifComponent },
    { path: 'planning', component: PlanningComponent },
    { path: 'document', component: DocumentComponent },
    { path: 'convention', component: ConventionComponent },
    { path: 'certification', component: CertificationComponent },
    { path: 'extranet', component: ExtranetComponent },
    { path: 'test', component: TestComponent },
    { path: 'tache', component: TacheComponent },
    { path: 'depense', component: DepensesComponent },
    { path: 'email', component: MailComponent },
    { path: 'reporting', component: StageReportingComponent },
  ]
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TagModule,
    BodisplayModule,
    CustomgridModule,
    ScrollingModule,
    RouterModule,
    AvatarSearchModule,
    PipeModule,
    DateModule,
    EffectifsModule,
    ReservationModule,
    //EffectifsClientsSurStageModule, 
    HistoryModule,
    SendMailModule,
    CKEditorModule,
    NgbModule,
    DynamictagsInlineModule,
    BoPropertyInlineModule,
    DynamicTagAddonModule,
    InsertDocModule,
    InsertDocInputModule,
    BoPropertyInlineModule,
    UtilitiesDirectivesModule,
    RelatedDocumentModule,
    FullCalendarModule,
    AutoSearchModule,
    QuestionnaireModule,
    QLeafMapModule,
    SearchModule,
    ESignatureModule,
    BasicEchartModule,
    ReportingModule
  ],
  providers: [],
  exports: [   
  ],
  declarations: [
    StageModalComponent,
    StageDuplicationComponent,

    Vue360Component,
    Documents360Component,

    EffectifComponent,
    LieuComponent,
   

    PlanningComponent,
    CalendrierComponent,
    ListeReservationComponent,
    PlanningCreationComponent,
    FormateursIdPipe,
    NumberToFixedPipe,
    ReservationsBureauComponent,

    DocumentComponent,
    ConventionComponent,
    ClientConventionComponent,
    CorpsConventionComponent,

    CertificationComponent,
    CreateObjectifComponent,

    ExtranetComponent,    
    PortailExtranetComponent,
    QuestionnairesExtranetComponent,
    AffectationComponent,
    DigitalLearningExtranetComponent,
    DepensesComponent,
    TestComponent,
    TacheComponent,
    AvatarSearchValue,
    TacheTableauComponent,
    MailComponent,
    MailOneComponent,
    MailTwoComponent,
    MailThreeComponent,
    StageReportingComponent,
    ListDocumentsComponent,
    GenerationDocumentsComponent,
    GenerationContratFormateurComponent,
    ListReservationComponent    
  ]
})

export class StageModalModule { }
